import {
  Absolute,
  Box,
  chain,
  Description,
  FAB,
  TextArea,
  VStack,
} from '@revolut-internal/ui-kit'
import { FC, useEffect, useState } from 'react'

import { usePrompt } from 'pages/AiProcessDebug/providers/PromptProvider'

type Props = {
  defaultValue: string
}

export const Prompt: FC<Props> = props => {
  const { defaultValue } = props

  const [value, setValue] = useState(defaultValue)

  const {
    isGeneratePending,
    currentFixedPromptTextGeneration,
    currentFixedPromptTextGenerationIndex,
    fixedPromptTextGenerationsCount,
    onGenerate,
  } = usePrompt()

  const fixedPromptText = currentFixedPromptTextGeneration?.content
  const resetValue = fixedPromptText ?? defaultValue
  const actionsDisabled = isGeneratePending || value === resetValue

  useEffect(() => {
    if (fixedPromptText) {
      setValue(fixedPromptText)
    }
  }, [fixedPromptText])

  return (
    <>
      <VStack>
        {fixedPromptTextGenerationsCount > 1 &&
        currentFixedPromptTextGenerationIndex > -1 ? (
          <Description>
            {chain(
              'Prompt',
              `Version ${
                currentFixedPromptTextGenerationIndex + 1
              }/${fixedPromptTextGenerationsCount}`,
            )}
          </Description>
        ) : (
          <Description>Prompt:</Description>
        )}
        <Box>
          <TextArea
            value={value}
            onChange={event => setValue(event.currentTarget.value)}
            disabled={isGeneratePending}
          />
        </Box>
      </VStack>
      <Absolute right={56} bottom={32}>
        <VStack space="s-20">
          <FAB
            useIcon="RevertLeft"
            variant="white"
            disabled={actionsDisabled}
            onClick={() => setValue(resetValue)}
          >
            Revert prompt
          </FAB>
          <FAB
            useIcon="ArrowExchange"
            disabled={actionsDisabled}
            onClick={() => onGenerate(value)}
          >
            Generate new prompt
          </FAB>
        </VStack>
      </Absolute>
    </>
  )
}
